var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from "react";

function SvgDistributor(props) {
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M21.418 4.693c.258 0 .467.214.467.478v8.952a.473.473 0 01-.467.478h-.774v9.035h.633c1.53 0 2.775-1.275 2.775-2.842v-4.842c0-.264.209-.478.467-.478.257 0 .466.214.466.478v4.842c0 2.094-1.663 3.799-3.708 3.799h-.633v2.929a.473.473 0 01-.466.478h-9.471a.472.472 0 01-.467-.478v-12.92h-.773a.472.472 0 01-.467-.48V5.171c0-.264.209-.478.467-.478zm-1.707 9.908h-8.537v12.443h8.537V14.6zm4.808-1.422c.257 0 .466.214.466.478v.765a.473.473 0 01-.466.478.473.473 0 01-.467-.478v-.765c0-.264.209-.478.467-.478zM20.95 5.65H9.933v7.996h11.018V5.649zm4.083-1.509a.459.459 0 01.66 0 .486.486 0 010 .676l-.765.784v1.692h.604c.258 0 .467.214.467.478v4.274a.473.473 0 01-.467.478H23.56a.473.473 0 01-.466-.478V7.77c0-.264.209-.478.466-.478h.436v-1.89c0-.125.05-.25.136-.338zm.033 4.108h-1.04v3.318h1.04V8.248z"
  }));
}

export default SvgDistributor;